import { render, staticRenderFns } from "./form-restricoes-estado.vue?vue&type=template&id=6f096ac0&"
import script from "./form-restricoes-estado.vue?vue&type=script&lang=js&"
export * from "./form-restricoes-estado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports